import { useContext, useEffect } from 'react'
import DownloadFile from '../DownloadFile'
import FileUploader from '../FileUploader'
import { ImportWizardContext, ImportFile } from 'app/components/ImportWizard'
import { legacyRoleRank } from 'app/types/roles'
import { notifyError } from 'app/services/notify.client'
import { csvToArray, useUser } from 'app/utils'
import { isSMCOrg } from 'lib/isSMCOrg'
import { debug } from 'lib/logging'

export default function Step1() {
  const user = useUser()
  const { csvFile, setCsvFile, setColumnMapping, setDataToImport, setDisableNext, setLocationWorkspaceMapping } =
    useContext(ImportWizardContext)
  if (!user) return null
  let csvFileRead: ImportFile[] | string | undefined

  useEffect(() => {
    if (csvFile === undefined) return
    let fileReader = new FileReader()
    fileReader.readAsText(csvFile)
    debug(`imports`, `step 1`, `fileReader`, fileReader)

    fileReader.onloadstart = () => {
      setDisableNext(true)
      setLocationWorkspaceMapping([])
      setDataToImport([])
    }

    fileReader.onload = (event) => {
      csvFileRead = csvToArray(event?.target?.result as string)
      debug(`imports`, `step 2`, `csvFileRead`, csvFileRead)
      if (Array.isArray(csvFileRead)) setDataToImport(csvFileRead)
    }

    fileReader.onloadend = () => {
      setDisableNext(false)
      setColumnMapping([])
    }

    fileReader.onerror = (evt) => {
      debug(`imports`, `file reading error`, evt)
      notifyError(`Error reading file ${csvFile.name}, please try again`)
      setDisableNext(true)
    }
  }, [csvFile])
  return (
    <>
      <div className="w-full grow overflow-hidden">
        <h5 className="mb-8">Upload a CSV file</h5>
        <div className="flex w-full flex-col justify-between gap-y-8 md:w-[622px]">
          <FileUploader
            name="importFile"
            classname="!p-0"
            file={csvFile}
            fileType="csv"
            allowedFiles={[`text/csv`]}
            disabled={(user.role ?? legacyRoleRank.workspaceUser) <= legacyRoleRank.orgUser}
            sizeLimit={2}
            onFileUpload={(file) => {
              if (file !== undefined) {
                setCsvFile(file)
              } else {
                setCsvFile(undefined)
                setDisableNext(true)
              }
            }}
          />
          <div className="flex h-[138px] w-full flex-col items-center justify-center gap-y-8 rounded-lg border border-subtle bg-surface p-6 align-middle md:w-[622px]">
            <span className="text-heading-xs text-strong">
              You get the best outcome by using our spreadsheet template
            </span>
            <DownloadFile
              className="btn btn-sm border border-default bg-surface !text-strong !no-underline shadow-elevation-1"
              message="Download template"
              link={
                user.workspaceId
                  ? `/public/Workspace Activity Import Template.csv`
                  : isSMCOrg(user.orgId)
                    ? `https://docs.google.com/spreadsheets/d/1vevM6qAt610OR1OeMPCqkVuvMT0MaZZNQ1-us0MWqrI/template/preview`
                    : `https://docs.google.com/spreadsheets/d/17qYQrXSPm3SCVeqs_BH3KtICC6zuH7Bn-upijzUO96E/template/preview`
              }
            />
          </div>
        </div>
      </div>
    </>
  )
}
